import React, { useState } from 'react';
import type { FieldKind } from './utils/system-canvas-cm.types';
import { collectKindsForSection, collectItemsForSubSection, getIconForKind, getLabelForKind } from './utils/system-canvas-cm.utils';
import type { SectionFieldIconsProps } from './utils/system-canvas-cm.types';
import { useTranslation } from 'react-i18next';
import ConfirmPopup from '../../../../Components/ModalPopup/confirm-popup';
import { CloseIcon } from '../../../../bombiix-icon';

const SectionFieldIcons: React.FC<SectionFieldIconsProps> = (props) => {
  const { t } = useTranslation('custom-module-system-canvas');
  const [confirmIndex, setConfirmIndex] = useState<number | null>(null);
  const [showConfirm, setShowConfirm] = useState<boolean>(false);
  const [confirmKind, setConfirmKind] = useState<FieldKind | null>(null);

  const kinds: FieldKind[] = props.mode === 'section' ? collectKindsForSection(props.section) : [];
  const items = props.mode === 'subsection' ? collectItemsForSubSection(props.subSection) : [];

  const requestDelete = (kind: FieldKind, index: number) => {
    if (!props.onDelete) return;
    if (showConfirm) return;
    setConfirmKind(kind);
    setConfirmIndex(index);
    setShowConfirm(true);
  };

  const handleConfirmDelete = () => {
    if (props.onDelete && confirmIndex !== null) {
      props.onDelete(confirmIndex);
    }
    setShowConfirm(false);
    setConfirmIndex(null);
    setConfirmKind(null);
  };

  const handleCancelDelete = () => {
    setShowConfirm(false);
    setConfirmIndex(null);
    setConfirmKind(null);
  };

  const deleteTitle = () => {
    if (confirmKind === 'table') {
      return t('CUSTOM_MODULE.SYSTEM_CANVAS.CONFIRM_DELETE_TABLE_TITLE');
    }
    if (confirmKind === 'comment') {
      return t('CUSTOM_MODULE.SYSTEM_CANVAS.CONFIRM_DELETE_COMMENT_TITLE');
    }
    return t('CUSTOM_MODULE.SYSTEM_CANVAS.CONFIRM_DELETE_FIELD_TITLE');
  };

  const deleteMessage = () => {
    if (confirmKind === 'table') {
      return t('CUSTOM_MODULE.SYSTEM_CANVAS.CONFIRM_DELETE_TABLE_MESSAGE');
    }
    if (confirmKind === 'comment') {
      return t('CUSTOM_MODULE.SYSTEM_CANVAS.CONFIRM_DELETE_COMMENT_MESSAGE');
    }
    return t('CUSTOM_MODULE.SYSTEM_CANVAS.CONFIRM_DELETE_FIELD_MESSAGE');
  };

  return (
    <div className="cm-dropzone">
      <div className="cm-selected-icons">
        {props.mode === 'section'
          ? kinds.map((kind, kindIndex) => {
              const Ico = getIconForKind(kind);
              if (!Ico) return null;
              return (
                <span
                  key={`${kind}-${kindIndex}`}
                  className="cm-ico cm-ico-lg d-inline-flex align-items-center justify-content-center"
                  title={getLabelForKind(kind)}
                >
                  <Ico size={DROPZONE_ICON_SIZE} />
                </span>
              );
            })
          : items.map(({ kind, index }) => {
              const Ico = getIconForKind(kind);
              if (!Ico) return null;
              if (kind === 'table' || kind === 'comment' || kind === 'canvas') {
                return (
                  <div key={`${kind}-${index}`} className="cm-block-icon" title={getLabelForKind(kind)}>
                    <Ico size={DROPZONE_ICON_SIZE} />
                    {props.onDelete && (
                      <span
                        className="cm-del text-ff0000 p-1 cursor-pointer"
                        aria-label={`Delete ${getLabelForKind(kind)}`}
                        onClick={() => requestDelete(kind, index)}
                      >
                        <CloseIcon size={24} />
                      </span>
                    )}
                  </div>
                );
              }
              return (
                <span
                  key={`${kind}-${index}`}
                  className="cm-ico cm-ico-lg cursor-pointer d-inline-flex align-items-center justify-content-center position-relative"
                  title={getLabelForKind(kind)}
                >
                  <Ico size={DROPZONE_ICON_SIZE} />
                  {props.onDelete && (
                    <span
                      className="cm-del text-ff0000 p-1 cursor-pointer"
                      aria-label={`Delete ${getLabelForKind(kind)}`}
                      onClick={() => requestDelete(kind, index)}
                    >
                      <CloseIcon size={24} />
                    </span>
                  )}
                </span>
              );
            })}
      </div>
      <ConfirmPopup onOpen={showConfirm} title={deleteTitle()} message={deleteMessage()} toggle={handleCancelDelete} onConfirm={handleConfirmDelete} />
    </div>
  );
};
export default SectionFieldIcons;

const DROPZONE_ICON_SIZE = 28;
